<div class="main-content">
    <header class="header">
        <div class="d-flex justify-content-between align-items-center">
            <a class="logo-link" routerLink="/">
                <app-extended-logo></app-extended-logo>
            </a>
            <div class="d-none d-lg-block" *ngIf="mainLogicService.isAfterWelcomeScreen() | async">
                <app-menu></app-menu>
            </div>
            <p-button
                    *ngIf="!(loggedUser$ | async)"
                    class="d-block"
                    styleClass="button-basic"
                    [label]="'COMPONENT.AUTH_LOGIN.LOG_IN_OR_REGISTER' | translate"
                    (click)="openAuthModal()"
                    type="button"></p-button>
            <app-logged-user-badge *ngIf="loggedUser$ | async" [user]="loggedUser$ | async"></app-logged-user-badge>
        </div>
    </header>

    <p-dialog [modal]="true" id="authDialog" [style]="{ width: '95vw', maxWidth: '552px' }" [header]="'COMPONENT.AUTH_MODAL.TITLE' | translate" [(visible)]="dialogVisible" (onHide)="dialogVisible = false">
        <app-auth-information-modal></app-auth-information-modal>
    </p-dialog>

    <div class="container">
        <div class="main-layout">
            <router-outlet></router-outlet>
        </div>
    </div>

    <app-footer *ngIf="!window.location.href.includes('questionnaire')"></app-footer>

    <div class="d-lg-none d-flex align-items-center justify-content-center menu-container" *ngIf="mainLogicService.isAfterWelcomeScreen() | async">
        <app-menu></app-menu>
    </div>

</div>
